"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactIdSwiper = _interopRequireDefault(require("react-id-swiper"));
require("swiper/css/swiper.css");
var _userflow = require("../../utils/userflow");
var _Button = _interopRequireDefault(require("../Button"));
var _MobileGalleryVideo = _interopRequireDefault(require("../MobileGalleryVideo"));
var _Throbber = _interopRequireDefault(require("../Throbber"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/* eslint-disable react/display-name */
var ArrowIcon = function ArrowIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2 2l10 23L2 48",
    stroke: "#FFF",
    strokeWidth: "3",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
ArrowIcon.defaultProps = {
  viewBox: "0 0 14 50",
  xmlns: "http://www.w3.org/2000/svg"
};
var MIN_HEIGHT = 210;
var MIN_WIDTH = 320;
var config = {
  loop: false,
  speed: 500,
  slidesPerView: 1,
  pagination: {
    el: '.swiper-progress',
    type: 'progressbar'
  },
  lazy: {
    loadPrevNext: true,
    preloaderClass: 'swiper-lt-preloader'
  }
};
var ArrowButton = function ArrowButton(_ref /* eslint-disable-line react/prop-types */) {
  var direction = _ref.direction;
  return /*#__PURE__*/_react["default"].createElement(StyledControlsButton, {
    className: "swiper-control-".concat(direction > 0 ? 'next' : 'prev'),
    "data-direction": direction,
    functional: true
  }, /*#__PURE__*/_react["default"].createElement(ArrowIcon, {
    width: 13,
    height: 50
  }));
};
var MobileGallery = function MobileGallery(_ref2) {
  var controls = _ref2.controls,
    counter = _ref2.counter,
    height = _ref2.height,
    images = _ref2.images,
    landscape = _ref2.landscape,
    loop = _ref2.loop,
    width = _ref2.width;
  var subConfig = {};
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    swiper = _useState2[0],
    setSwiper = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    currentIndex = _useState4[0],
    updateCurrentIndex = _useState4[1];
  if (counter) {
    subConfig.getSwiper = setSwiper;
    (0, _react.useEffect)(function () {
      if (swiper !== null) {
        swiper.on('slideChange', function () {
          return updateCurrentIndex(swiper.realIndex);
        });
      }
      return function () {
        if (swiper !== null) {
          swiper.off('slideChange', function () {
            return updateCurrentIndex(swiper.realIndex);
          });
        }
      };
    }, [swiper]);
  }
  subConfig.loop = loop;
  if (controls) {
    subConfig.navigation = {
      nextEl: '.swiper-control-next',
      prevEl: '.swiper-control-prev'
    };
    subConfig.renderPrevButton = function () {
      return /*#__PURE__*/_react["default"].createElement(ArrowButton, {
        direction: -1
      });
    };
    subConfig.renderNextButton = function () {
      return /*#__PURE__*/_react["default"].createElement(ArrowButton, {
        direction: 1
      });
    };
  }
  return /*#__PURE__*/_react["default"].createElement(StyledContainer, {
    width: width
  }, /*#__PURE__*/_react["default"].createElement(_reactIdSwiper["default"], (0, _extends2["default"])({}, config, subConfig), images.map(function (item) {
    var content = item.special.content;
    var _item$images = item.images,
      thumbImage = _item$images.thumbImage,
      thumbImageX2 = _item$images.thumbImageX2;
    return content ? /*#__PURE__*/_react["default"].createElement("div", {
      key: thumbImage
    }, /*#__PURE__*/_react["default"].createElement(_MobileGalleryVideo["default"], {
      data: item,
      height: height,
      landscape: landscape
    })) : /*#__PURE__*/_react["default"].createElement("div", {
      className: "swiper-slide",
      key: thumbImage
    }, /*#__PURE__*/_react["default"].createElement(StyledImage, {
      "data-background": (0, _userflow.getFullUrl)(thumbImageX2),
      className: "swiper-lazy",
      height: height,
      cover: !landscape
    }, /*#__PURE__*/_react["default"].createElement(_Throbber["default"], {
      className: "swiper-lt-preloader"
    })));
  })), counter && /*#__PURE__*/_react["default"].createElement(StyledCounter, null, "".concat(currentIndex + 1, " \u0438\u0437 ").concat(images.length)));
};
MobileGallery.propTypes = {
  controls: _propTypes["default"].bool,
  counter: _propTypes["default"].bool,
  images: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    images: _propTypes["default"].shape({
      smallImage: _propTypes["default"].string,
      fullImage: _propTypes["default"].string,
      thumbImage: _propTypes["default"].string.isRequired,
      thumbImageX2: _propTypes["default"].string
    }).isRequired,
    special: _propTypes["default"].shape({
      id: _propTypes["default"].number,
      content: _propTypes["default"].string,
      title: _propTypes["default"].string
    }).isRequired
  })).isRequired,
  height: _propTypes["default"].number,
  landscape: _propTypes["default"].bool,
  loop: _propTypes["default"].bool,
  width: _propTypes["default"].number
};
MobileGallery.defaultProps = {
  controls: false,
  counter: false,
  height: MIN_HEIGHT,
  landscape: false,
  loop: false,
  width: MIN_WIDTH
};
var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "MobileGallery__StyledContainer",
  componentId: "sc-1o5m93e-0"
})(["min-width:", "px;position:relative;width:100%;.swiper-container-horizontal > .swiper-pagination-progressbar{position:relative;height:1px;background:none;.swiper-pagination-progressbar-fill{background:", ";}}"], function (props) {
  return props.width;
}, function (props) {
  return props.theme.colors.blackBase;
});
var StyledImage = _styledComponents["default"].div.withConfig({
  displayName: "MobileGallery__StyledImage",
  componentId: "sc-1o5m93e-1"
})(["background-size:", ";background-repeat:no-repeat;background-position:50%;background-color:", ";height:", "px;"], function (props) {
  return props.cover ? 'cover' : 'auto 100%';
}, function (props) {
  return props.theme.colors.blackBase;
}, function (props) {
  return props.height;
});
var StyledControlsButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "MobileGallery__StyledControlsButton",
  componentId: "sc-1o5m93e-2"
})(["width:13px;height:50px;transition:opacity 120ms ease;right:10px;position:absolute;z-index:2;top:50%;margin-top:-25px;filter:drop-shadow(0px 1px 4px rgba(0,0,0,0.5));&[aria-disabled='true']{display:none;}", ";"], function (props) {
  return props['data-direction'] < 0 ? "\n    left: 10px;\n    transform: rotate(180deg);\n  " : "\n    right: 10px;\n  ";
});
var StyledCounter = _styledComponents["default"].div.withConfig({
  displayName: "MobileGallery__StyledCounter",
  componentId: "sc-1o5m93e-3"
})(["", ";background:", ";border-radius:18px;bottom:16px;color:", ";line-height:24px;padding:0 10px;position:absolute;right:12px;z-index:3;"], function (props) {
  return props.theme.typography.t1s;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.blackBase;
}, function (props) {
  return props.theme.colors.white;
});
MobileGallery.StyledCounter = StyledCounter;
var _default = exports["default"] = MobileGallery;